import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getCenters = store => store[NAME].centers;
export const getProjects = store => store[NAME].projects;
